/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newCartLoyaltyButtonSchema = z.object({
	cart_loyalty_button_text: z.string().nullable(),
	cart_loyalty_button_sticker: z.string().nullable(),
});
